<script>
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  export let target;
  export let newPage = true;

  let percent = 0;

  //reactive
  $: percentValue = percent * 100;
  //tweened value
  const tweenedPercent = tweened(0, {
    duration: 400,
    easing: cubicOut,
  });
  $: tweenedPercent.set(percentValue);

  const onEnter = () => {
    percent = 1;
  };
  const onLeave = () => {
    percent = 0;
  };
</script>

<div class="link">
  {#if newPage}
    <a
      href={target}
      target="_blank"
      rel="noopener noreferrer"
      on:mouseenter={onEnter}
      on:mouseleave={onLeave}
      ><slot /> <i class="fa-solid fa-up-right-from-square" /></a
    >
  {:else}
    <a href={target}><slot /> <i class="fa-solid fa-up-right-from-square" /></a>
  {/if}
  <div class="underline" style="width: {$tweenedPercent}%" />
</div>

<style>
  .link {
    display: inline-block;
    position: relative;
  }
  i {
    font-size: 0.8rem;
  }
  .link a {
    color: #1a91bc;
  }
  .link a:hover {
    text-decoration: none;
  }
  .underline {
    height: 10%;
    position: absolute;
    box-sizing: border-box;
    background: #1a91bc;
  }
</style>
